import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BattleClient } from "./components/BattleClient";
import "./globals.css";
import "./game.css";

const root = document.getElementById("root");

if (!root) throw new Error("Application root was not found");

createRoot(root).render(
  <StrictMode>
    <BattleClient />
  </StrictMode>,
);
